<template>
  <div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <v-register-commercial-card
          research-type="benchmark"
          color="info"
          title="Benchmark"
          :price="300"
          icon="pie-chart"
          @research-type-selected="$emit('research-type-selected', 'benchmark')"
        >
          <template slot="subtitle">
            Krijg snel <strong>inzicht</strong> in je radiocommercial met het grondige
            benchmarkonderzoek
          </template>

          <template slot="content">
            <v-check-six-categories
              title="Benchmarking van je commercial op 6 dimensies"
            />
            <hr/>
            <v-check-commercial-questions
              commercial-type="radio"
              research-type="benchmark"
            />
            <hr/>
            <v-check-add-custom-question/>
            <hr/>
            <v-check-pdf-report/>
            <hr/>
            <v-check-number-of-reviewers
              :amount="200"
            />
            <hr/>
            <v-check-commercial-dashboard/>
            <hr/>
            <v-check-csv-export/>
          </template>
        </v-register-commercial-card>
      </div>
      <div class="col-md-6 mb-3">
        <v-register-commercial-card
          research-type="research"
          title="Research"
          color="success"
          :price="BASE_PRICES.research"
          icon="magnifying-glass"
          button-text="phrase.request"
          @research-type-selected="$emit('research-type-selected', 'test')"
        >
          <template v-slot:subtitle>
            Uitgebreide <strong>pre- of posttest</strong> van je marketinguiting
            (beschikbaar in Nederland, Vlaanderen & Wallonië)
          </template>
          <template v-slot:content>
            <div>
              <i class="fa fa-check text-success"></i>
              Representatieve testgroep (standaard n=100)
            </div>
            <hr/>
            <div>
              <i class="fa fa-check text-success"></i>
              Kies je eigen doelgroep op basis van leeftijd, geslacht of een andere eigenschap
            </div>
            <hr/>
            <div>
              <i class="fa fa-check text-success"></i>
              Vrijheid in het samenstellen van de vragen
            </div>
            <hr/>
            <div>
              <i class="fa fa-check text-success"></i>
              Kies je testmateriaal: afbeelding, schets, tekst, animatie, video, audio etc.
            </div>
            <hr/>
            <v-check-commercial-dashboard/>
            <hr/>
            <v-check-csv-export/>
            <hr/>
            <div>
              <i class="fa fa-check text-success"></i>
              Advies vanuit Commercialreview bij opzet en analyse
            </div>
          </template>
        </v-register-commercial-card>
      </div>
    </div>
    <v-partner-carousel/>
  </div>
</template>

<script>
import PartnerCarousel from '@/common/components/carousels/PartnerCarousel.vue';
import { BASE_PRICES } from '@/common/utils/constants';
import AddCustomQuestion from '@/common/components/registration/AddCustomQuestion.vue';
import CommercialQuestions from '@/common/components/registration/CommercialQuestions.vue';
import CommercialDashboard from '@/common/components/registration/CommercialDashboard.vue';
import NumberOfReviewers from '@/common/components/registration/NumberOfReviewers.vue';
import PdfReport from '@/common/components/registration/PdfReport.vue';
import CheckSixCategories from '@/common/components/registration/SixCategories.vue';
import CsvExport from '@/common/components/registration/CsvExport.vue';
import RegisterCommercialCard from '@/common/components/registration/RegisterCommercialCard.vue';

export default {
  name: 'RegisterCommercialStartRadio',
  components: {
    'v-check-add-custom-question': AddCustomQuestion,
    'v-check-commercial-questions': CommercialQuestions,
    'v-check-commercial-dashboard': CommercialDashboard,
    'v-check-number-of-reviewers': NumberOfReviewers,
    'v-check-pdf-report': PdfReport,
    'v-check-six-categories': CheckSixCategories,
    'v-check-csv-export': CsvExport,
    'v-partner-carousel': PartnerCarousel,
    'v-register-commercial-card': RegisterCommercialCard,
  },
  data() {
    return {
      BASE_PRICES,
    };
  },
};
</script>
